export const ONLY_LETTERS = /^[A-Z-]+$/i

export const PASSWORD = /^(?=.*\d)(?=.*(_|[^\w])).+$/

export const PERCENT = /[^0-9]/g // TODO Find regex from 1 to 100

export const NUMBER = /[^0-9.-]/g

export const NUMBER_FORMATTER = /\B(?=(\d{3})+(?!\d))/g // ділить число по 3 -> 1|234|567

export const PHONE_NUMBER =
  /^((\+[1-9]{1,4}[ \-]*)|(\([0-9]{2,3}\)[ \-]*)|([0-9]{2,4})[ \-]*)*?[0-9]{3,4}?[ \-]*[0-9]{3,4}?$/

export const EMAIL_REGEX = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/